export default __webpack_public_path__ + "assets/images/4c57925a26eab0e916713c092dd064de.png";